/** Categories sold as contact-only (no Flea cart / delivery). */
export const ELECTRONICS_CATEGORY = 'Computers & Electronics';

export const CONTACT_ONLY_CATEGORIES = [
  ELECTRONICS_CATEGORY,
];

export function isContactOnlyListingCategory(category) {
  return CONTACT_ONLY_CATEGORIES.includes(String(category || '').trim());
}

/** Electronics always share seller phone for inspection & delivery contact. */
export function isElectronicsListingCategory(category) {
  return String(category || '').trim() === ELECTRONICS_CATEGORY;
}
